import { TransactionsProviderState } from './types';

const defaultTransactionsProviderState: TransactionsProviderState = {
  checkAuthorizationData: null,
  transactionsList: null,
  transactionDetails: null,
  selectedTransaction: null,
  onCheckAuthorizationMutation: () => {},
  actions: {
    onSelectTransaction: () => {},
    onRefetchTransactionDetails: () => {},
  },
  loadingState: {
    isLoadingTransactionDetails: false,
    isLoadingCheckAuthorization: false,
  },
  errorState: {
    transactionDetailsError: undefined,
    checkAuthorizationError: undefined,
  },
};

export { defaultTransactionsProviderState };
